import { API } from '@Root/API'

export const getStatic = () => {
	return Promise.all([API.admin.institution.getRelated()])
}
